import { shouldAllowSearchIndexing } from '~/utils/seo-allowlist.js'
import { isOfflineExemptRoute } from '~/utils/offline-routes.js'

export default function ({ route, store, redirect, res }) {

    if (process.server && res) {
        const isProduction = process.env.VUE_APP_ENV === 'production'
        if (!isProduction) {
            res.setHeader('X-Robots-Tag', 'noindex, nofollow')
        } else {
            const block = store.getters.getBlockSearchEngineIndexing
            if (!shouldAllowSearchIndexing(route.name, block)) {
                res.setHeader('X-Robots-Tag', 'noindex, nofollow')
            }
        }
    }

    let isMaintenance = process.env.VUE_APP_MAINTENANCE;
    if(isMaintenance == 'true') {
      store.commit("app/SET_DOWN_FOR_MAINTENANCE",true);
    } else {
      store.commit("app/SET_DOWN_FOR_MAINTENANCE",false);
    }

    // if trying to go to mainenance page and the app isn't down for maintenance then navigate home
    if(route.name == 'maintenance' && !store.getters['app/getDownForMaintenance'])
        return redirect('/');

    if(route.name != 'maintenance' && store.getters['app/getDownForMaintenance']){
        return redirect('/maintenance');
    }

    let step_nav = false;
    switch(route.name){
      case 'delivery':
      step_nav = 1;
      break;
      case 'billing':
      step_nav = 1.5; // billing is a sub-step of delivery
      break;
      case 'payment':
      step_nav = 2;
      break;
      case 'order-confirmation':
      step_nav = 3;
      break;
      default:
      step_nav = false;
    }

    let checkout_step = store.getters['persisted/getCheckoutStep'];
    const store_status = store.getters.getStoreStatus;
    const account = store.getters.getAccount;

    let loading = store.getters.getLoading; // we've not got any data from the API yet, or in local storage
    if(account.id && !store_status && !loading){ // store not live

        if(!isOfflineExemptRoute(route.name)){
          return redirect('/offline')
        }
        else{
            //next();
        }
    }

    // if trying to go to the offline page but the store is actually live, navigate home
    if(route.name == 'offline' && account.id && store_status && !loading){
        return redirect('/')
    }

    if(process.client){

      // ensure you can't go passed the checkout step you've not completed
      if (step_nav) {
          if (step_nav > checkout_step) {
            return redirect('/')
          } else {
              //next();
          }
      } else {
        store.commit("persisted/CHECKOUT_STEP",0);
          //next();
      }
    }


}
